import Scene from './Scene';
import common from '../common';
import {translate, Text} from '../utils';
import ParticleEmitter from '../particles/ParticleEmitter';

export default class EndScene extends Scene {
	constructor(score) {
		super();

		this.score 			= score;
		this.repeatButton 	= null;
		this.homeButton		= null;
		this.playButton 	= null;
		this.coinText 		= null;
		this.blockText		= null;
		this.block			= null;
		this.scoreText		= null;
		this._backgroundMusic = null;
		this.highscoreText	= null;
		this._competitionButton = null;
		this._competitionText = null;
		this.panelMiddle	= null;
		this.completedLevels = null;
		this._greenParticles = null;
		this._spine = null;
		this.paused = false;
		this.currentLevel = null;
		this.tweenedValues 	= [];
		this._particles = [];
	}

	init() {
		super.init();
		const bg = new PIXI.Sprite(P3.assets.texture('ui_bg_1'));

		bg.anchor.set(0.5);
		bg.position.set((common.STAGE_WIDTH * 0.5), (common.STAGE_HEIGHT * 0.5));
		bg.width = 2000;
		this.addChild(bg);

		for (let i = 0; i < 4; i++) {
			const codetile = new PIXI.Sprite(P3.assets.texture('ui_bg_1_tile'));

			codetile.anchor.set(0, 0.5);
			codetile.position.set(-68 + (i * 450), (common.STAGE_HEIGHT * 0.5));
			this.addChild(codetile);
		}

		this._createVerticalLines(12);
		this._createHorizontalLines(4);

		const frameTop = new PIXI.Container();
		frameTop.rotation = 180 * PIXI.DEG_TO_RAD;
		this.addChild(frameTop);

		const frameTop1 = new PIXI.Sprite(P3.assets.texture('ui_frame'));
		frameTop1.anchor.set(0, 0);
		frameTop1.scale.x = -1;
		frameTop.addChild(frameTop1);

		const frameTop2 = new PIXI.Sprite(P3.assets.texture('ui_frame'));
		frameTop2.anchor.set(0, 0);
		frameTop.addChild(frameTop2);

		const frameBottom = new PIXI.Container();
		this.addChild(frameBottom);

		const frameBottom1 = new PIXI.Sprite(P3.assets.texture('ui_frame'));
		frameBottom1.anchor.set(1, 1);
		frameBottom.addChild(frameBottom1);

		const frameBottom2 = new PIXI.Sprite(P3.assets.texture('ui_frame'));
		frameBottom2.anchor.set(1, 1);
		frameBottom2.scale.x = -1;
		frameBottom.addChild(frameBottom2);

		frameBottom.position.set((common.STAGE_WIDTH * 0.5), common.STAGE_HEIGHT);
		frameTop.position.set((common.STAGE_WIDTH * 0.5), frameTop.height);

		const titletext = Text(`// ${translate('MENU.RESULTS.TITLE')}`, {font: '48px ZCOOL QingKe HuangYou', align: 'center'});
		titletext.tint = 0xB3FF47;
		titletext.anchor.set(0.5);
		titletext.position.set((common.STAGE_WIDTH * 0.5), 60);
		this.addChild(titletext);

		const caretText = Text('_', {font: '48px ZCOOL QingKe HuangYou', align: 'center'});
		caretText.tint = 0xB3FF47;
		caretText.anchor.set(0, 0.5);
		caretText.position.set(titletext.x + (titletext.width * 0.5) + 10, 62);
		this.addChild(caretText);

		new P3.utils.TWEEN.Tween(caretText, this.tweens)
			.to({
				alpha: 0
			}, 1)
			.easing(P3.utils.TWEEN.Easing.Linear.None)
			.delay(500)
			.yoyo(true)
			.repeat(Infinity)
			.start();

		let states = new P3.ButtonStates();
		states.normal = P3.assets.texture('ui_btn_large_out');
		states.over = P3.assets.texture('ui_btn_large_over');
		states.down = P3.assets.texture('ui_btn_large_down');
		states.icon = P3.assets.texture('ui_icon_play');

		this.playButton = new P3.Button(states);
		this.playButton.visible = false;
		this.playButton.clickSoundName = 'sfx_btn_press_00';
		this.playButton.overSoundName = 'sfx_btn_rollover_00';
		this.playButton.signals.click.add(() => {
			this.signals.next.dispatch(this);
		}, this);
		this.playButton.position.set((common.STAGE_WIDTH * 0.5) + 410, (common.STAGE_HEIGHT * 0.5) + 275);

		states = new P3.ButtonStates();
		states.normal = P3.assets.texture('ui_btn_large_out');
		states.over = P3.assets.texture('ui_btn_large_over');
		states.down = P3.assets.texture('ui_btn_large_down');
		states.icon = P3.assets.texture('ui_icon_replay');

		this.repeatButton = new P3.Button(states);
		this.repeatButton.visible = false;
		this.repeatButton.clickSoundName = 'sfx_btn_press_00';
		this.repeatButton.overSoundName = 'sfx_btn_rollover_00';
		this.repeatButton.signals.click.add(() => {
			this.signals.previous.dispatch(this);
		}, this);
		this.repeatButton.position.set((common.STAGE_WIDTH * 0.5) - 410, (common.STAGE_HEIGHT * 0.5) + 275);
		this.addChild(this.repeatButton);

		states = new P3.ButtonStates();
		states.normal = P3.assets.texture('ui_btn_small_out');
		states.over = P3.assets.texture('ui_btn_small_over');
		states.down = P3.assets.texture('ui_btn_small_down');
		states.icon = P3.assets.texture('ui_icon_home');

		this.homeButton = new P3.Button(states);
		this.homeButton.interactive = false;
		this.homeButton.clickSoundName = 'sfx_btn_press_00';
		this.homeButton.overSoundName = 'sfx_btn_rollover_00';
		this.homeButton.visible = false;

		this.homeButton.signals.click.add(() => {
			this.signals.home.dispatch(this);
		}, this);

		this.addChild(this.homeButton);

		const resultspanel = this._createResultsPanel();
		resultspanel.position.set((common.STAGE_WIDTH * 0.5), (common.STAGE_HEIGHT * 0.5));
		this.addChild(resultspanel);

		// char_ben
		this._spine = new PIXI.spine.Spine(P3.assets.spineData('char_ben'));
		this._spine.scale.set(0.75);
		this._spine.skeleton.setToSetupPose();
		this._spine.autoUpdate = false;
		this._spine.position.set((common.STAGE_WIDTH * 0.5) - 300, (common.STAGE_HEIGHT * 0.5) + 200);
		this.addChild(this._spine);

		this.playCompleteAnim();

		this.addChild(this.playButton);

		if (common.config.competition_enabled) {
			this._createCompetitionFrame();
		}
	}

	_createHorizontalLines(count) {
		for (let i = 0; i < count; i++) {
			const line = new PIXI.Sprite(P3.assets.texture('ui_bg_gridline'));

			line.anchor.set(0.5);
			line.alpha = P3.math.random(0.2, 0.7);
			line.rotation = (P3.math.random(-5, 5) * PIXI.DEG_TO_RAD) + (90 * PIXI.DEG_TO_RAD);
			line.height = common.STAGE_WIDTH;
			line.position.set((common.STAGE_WIDTH * 0.5), (common.STAGE_HEIGHT / count) * i);
			this.addChild(line);

			// up-down anim
			new P3.utils.TWEEN.Tween(line.position, this.tweens)
				.to({
					y: line.position.y + P3.math.random(-100, 100)
				}, 3000)
				.easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
				.delay(P3.math.random(500, 1500))
				.repeatDelay(0)
				.yoyo(true)
				.repeat(Infinity)
				.start();
		}
	}

	_createVerticalLines(count) {
		for (let i = 0; i < count; i++) {
			const line = new PIXI.Sprite(P3.assets.texture('ui_bg_gridline'));
			const angle = P3.math.random(-10, 10);

			line.anchor.set(0.5);
			line.alpha = P3.math.random(0.2, 1);
			line.rotation = angle * PIXI.DEG_TO_RAD;
			line.height = common.STAGE_HEIGHT;
			line.position.set((common.STAGE_WIDTH / count) * i, (common.STAGE_HEIGHT * 0.5));
			this.addChild(line);

			// left-right anim
			new P3.utils.TWEEN.Tween(line.position, this.tweens)
				.to({
					x: line.position.x + P3.math.random(-100, 100)
				}, 3000)
				.easing(P3.utils.TWEEN.Easing.Sinusoidal.InOut)
				.delay(P3.math.random(500, 1500))
				.repeatDelay(0)
				.yoyo(true)
				.repeat(Infinity)
				.start();
		}
	}

	_createResultsPanel() {
		this.completedLevels = JSON.parse(localStorage.getItem('completed_levels'));
		this.currentLevel = this.completedLevels[common.currentLevel];

		const container = new PIXI.Container();

		const panelTop = new PIXI.Sprite(P3.assets.texture('ui_results_panel_top'));
		panelTop.anchor.set(0.5);
		panelTop.position.set(0, -230);
		container.addChild(panelTop);

		const stageText = Text(`${common.currentLevel + 1}`, {font: '72px ZCOOL QingKe HuangYou', align: 'center'});
		stageText.tint = 0xFFFFFF;
		stageText.anchor.set(0.5);
		stageText.position.set(0, 0);
		panelTop.addChild(stageText);

		this.panelMiddle = new PIXI.Sprite(P3.assets.texture('ui_results_panel_middle'));
		this.panelMiddle.anchor.set(0.5);
		container.addChild(this.panelMiddle);

		this.block = new PIXI.mesh.NineSlicePlane(P3.assets.texture('ui_function_9slice_playback'), 80, 0, 20, 0);
		this.block.width = 75;
		this.block.height = 50;
		this.block.tint = 0x00FF00;
		this.block.position.set(-100, -140);
		this.panelMiddle.addChild(this.block);

		this.blockText = Text(`0/${common.levelSettings.minimumBlocks}`, {font: '48px Ahkio Regular', align: 'center'});
		this.blockText.tint = 0xFFFFFF;
		this.blockText.anchor.set(0.5);
		this.blockText.position.set((this.block.width * 0.5) - 90, (this.block.height * 0.5));
		this.block.addChild(this.blockText);

		const coinIcon = new PIXI.Sprite(P3.assets.texture('ui_icon_omnitrix_end'));
		coinIcon.anchor.set(0.5);
		coinIcon.scale.set(1.2);
		coinIcon.position.set(60, -110);
		this.panelMiddle.addChild(coinIcon);

		this.coinText = Text('0', {font: '60px Ahkio Numbers', align: 'center'});
		this.coinText.tint = 0xFFFFFF;
		this.coinText.anchor.set(0, 0.5);
		this.coinText.position.set(110, -110);
		this.panelMiddle.addChild(this.coinText);

		this.scoreText = Text('0', {font: '120px Ahkio Numbers', align: 'center'});
		this.scoreText.tint = 0xFFFFFF;
		this.scoreText.anchor.set(0.5);
		this.scoreText.position.set(0, 10);
		this.panelMiddle.addChild(this.scoreText);

		const highScore = this.getHighScore();
		this.highscoreText = Text(`${highScore}`, {font: '60px Ahkio Numbers', align: 'center'});
		this.highscoreText.tint = 0xEAE700;
		this.highscoreText.anchor.set(0.5);
		this.highscoreText.position.set(30, 80);
		this.panelMiddle.addChild(this.highscoreText);

		this.animateScore(0, common.scoring.points, 2000, true, 2000);

		const trophyIcon = new PIXI.Sprite(P3.assets.texture('ui_icon_hi_score'));
		trophyIcon.anchor.set(0.5);
		trophyIcon.position.set(-65, 80);
		this.panelMiddle.addChild(trophyIcon);

		const panelBottom = new PIXI.Sprite(P3.assets.texture('ui_results_panel_bottom'));
		panelBottom.anchor.set(0.5);
		panelBottom.position.set(0, 200);
		container.addChild(panelBottom);

		const playStarSound = i => {
			P3.audio.playSound(`sfx_star_impact_0${i}`);
		};

		const levelStars = this.getStars();
		this.currentLevel.score = levelStars;

		const positions = [
			{x: -82, y: 185},
			{x: 0, y: 205},
			{x: 82, y: 185}
		];

		for (let i = 0; i < levelStars; i++) {
			const star = new PIXI.Sprite(P3.assets.texture('ui_results_star'));
			star.anchor.set(0.5);
			star.scale.set(2);
			star.visible = false;
			star.position.copy(positions[i]);
			container.addChild(star);

			new P3.utils.TWEEN.Tween(star.scale, this.tweens)
				.to({x: 1, y: 1}, 400)
				.easing(P3.utils.TWEEN.Easing.Quartic.Out)
				.delay(2000 + (i * 500))
				.onStart(() => {
					star.visible = true;
				})
				.onComplete(() => {
					const starParticles = new ParticleEmitter('particle_2d_results_star_appear_00', [
						P3.assets.texture('particle_star')
					], true).playDuration(500);
					this._particles.push(starParticles);
					star.addChild(starParticles);
					playStarSound(i);
				})
				.start();
		}

		return container;
	}

	updateHighscore(totalScore) {
		const cookie = JSON.parse(localStorage.getItem('competition_entry'));

		if (cookie) {
			this.playButton.interactive = false;
			this.repeatButton.interactive = false;

			new Promise((resolve, reject) => {
				this.getCompetitionEntry(cookie.payload.id, resolve, reject);
			}).then((data) => {
				data.payload.score = totalScore;

				new Promise((resolve, reject) => {
					this.setDBScore(data, resolve, reject);
				}).then((data) => {
					this.playButton.interactive = true;
					this.repeatButton.interactive = true;
					localStorage.setItem('competition_entry', JSON.stringify(data));
				}).catch((error) => {
					this.playButton.interactive = true;
					this.repeatButton.interactive = true;
					console.error('error when setting new high score', error);
				});
			}).catch((error) => {
				this.playButton.interactive = true;
				this.repeatButton.interactive = true;
				console.error('error when getting competition data', error);
			});
		} else {
			console.log('no cookie found/user has not entered comp');
		}
	}

	destroy() {
		super.destroy();
		P3.audio.stopMusic();
	}

	pulse(colour) {
		this.block.alpha = 0;
		this.blockText.tint = colour;
		this.block.tint = colour;
		new P3.utils.TWEEN.Tween(this.block, this.tweens)
			.to({alpha: 1}, 200)
			.easing(P3.utils.TWEEN.Easing.Linear.None)
			.start();
	}

	animateBlocks() {
		if (this.score.blocks === common.levelSettings.minimumBlocks) {
			this.blockText.text = `${this.score.blocks}/${common.levelSettings.minimumBlocks}`;
			this.animateCoins();
		} else if (this.score.blocks > common.levelSettings.minimumBlocks) {
			this.tweenedValues.push(common.levelSettings.minimumBlocks);

			new P3.utils.TWEEN.Tween({a: 0}, this.tweens)
				.to({a: this.score.blocks}, this.score.blocks * 500)
				.easing(P3.utils.TWEEN.Easing.Linear.None)
				.onUpdate((v) => {
					const val = Math.floor(v.a);

					this.blockText.text = `${val}/${common.levelSettings.minimumBlocks}`;
					if (val % 1 === 0 && !this.tweenedValues.includes(val)) {
						this.tweenedValues.push(val);
						P3.audio.playSound('sfx_score_extramove_00');

						const color = val > common.levelSettings.minimumBlocks ? 0xFF0000 : 0xFFFFFF;
						this.pulse(color);
					}
				})
				.onComplete(() => {
					this.pulse(0xFF0000);
					this.animateCoins();
				})
				.delay(1000)
				.start();
		} else {
			new P3.utils.TWEEN.Tween({a: 0}, this.tweens)
				.to({a: this.score.blocks}, this.score.blocks * 500)
				.easing(P3.utils.TWEEN.Easing.Linear.None)
				.onUpdate((v) => {
					const val = Math.floor(v.a);

					this.blockText.text = `${val}/${common.levelSettings.minimumBlocks}`;
					if (val % 1 === 0 && !this.tweenedValues.includes(val)) {
						this.tweenedValues.push(val);
						P3.audio.playSound('sfx_score_goodmove_00');
						this.pulse(0xFFFFFF);
					}
				})
				.onComplete(() => {
					this.animateAddScore(this.block.position, common.scoring.command * (common.levelSettings.minimumBlocks - this.score.blocks));

					P3.utils.delay(0.5, () => {
						this.animateCoins();
					}, this);
				})
				.start();
		}
	}

	animateAddScore(from, amount) {
		const scoreText = Text(`${amount}`, {font: '52px Ahkio Regular', align: 'center'});

		scoreText.tint = 0xFFFFFF;
		scoreText.anchor.set(0.5);
		scoreText.position.copy(from);
		this.panelMiddle.addChild(scoreText);

		new P3.utils.TWEEN.Tween(scoreText, this.tweens)
			.to({
				x : 0, y : 10
			}, 200)
			.easing(P3.utils.TWEEN.Easing.Quadratic.Out)
			.onComplete(() => {
				const s = parseInt(this.scoreText.text, 10);
				this.animateScore(s, s + amount, 200);
				scoreText.destroy();
			})
			.start();
	}

	animateScore(fromValue, toValue, time, first = false, delay = 0) {
		let sound = null;

		new P3.utils.TWEEN.Tween({score: fromValue}, this.tweens)
			.to({score: toValue}, time)
			.easing(P3.utils.TWEEN.Easing.Linear.None)
			.onUpdate((v) => {
				const val = Math.floor(v.score);

				this.scoreText.text = val.toString();

				if (parseInt(this.highscoreText.text, 10) < val) {
					this.highscoreText.text = val.toString();
				}
			})
			.onStart(() => {
				sound = P3.audio.playSound('sfx_score_counter_00', {loop: true});
			})
			.onComplete(() => {
				if (first) {
					this.animateBlocks();
				}

				const levelScore = this.getLevelScore();
				const highScore = this.getHighScore();

				this.highscoreText.text = levelScore > highScore ? levelScore.toString() : highScore.toString();

				sound.stop();
			})
			.delay(delay)
			.start();
	}

	getLevelScore() {
		return this.currentLevel.points + (this.currentLevel.coins * common.scoring.coin);
	}

	getHighScore() {
		return this.completedLevels && this.currentLevel ? this.currentLevel.highscore : 0;
	}

	getStars() {
		const levelScore = this.getLevelScore();

		// player always get 1 star
		let levelStars = 1;

		// possible best - 750points = 2 stars
		if (levelScore >= common.bestScores[common.currentLevel] - 750) {
			levelStars++;
		}

		if (levelScore >= common.bestScores[common.currentLevel]) {
			levelStars++;
		}

		return levelStars;
	}

	getTotalScore() {
		let total = 0;

		for (const i in this.completedLevels) {
			const entry = this.completedLevels[i];

			total += entry.highscore;
		}

		return total;
	}

	setScore() {
		const currentScore = parseInt(this.scoreText.text, 10);

		if (currentScore > this.currentLevel.highscore) {
			this.currentLevel.highscore = currentScore;
		}

		common.totalScore = this.getTotalScore();

		this.updateHighscore(common.totalScore);

		const cookie = JSON.parse(localStorage.getItem('competition_entry'));

		if (cookie && common.config.competition_enabled) {
			this._competitionFrame.scoreText.text = `${common.totalScore}`;
			this._competitionFrame.subheader.text = translate('MENU.SELECT_LEVEL.COMPETITION.PARENTAL_CONSENT');

			this._competitionFrame.scoreText.position.set(this._competitionText.x + this._competitionText.width + 10, this._competitionText.y);
			this._scoreFrame.position.set(this._scoreFrame.width * -0.5, this._competitionFrame.bg.height * -0.5 + 20);
			this._competitionFrame.subheader.position.set(0, 20);

			this.resizeFrame();
		}

		localStorage.setItem('completed_levels', JSON.stringify(this.completedLevels));
	}

	animateCoins() {
		if (this.score.coins <= 0) {
			this.tweenButtons();

			return;
		}

		this.tweenedValues = [];

		new P3.utils.TWEEN.Tween({a: 1}, this.tweens)
			.to({
				a: this.score.coins
			}, 400 * this.score.coins)
			.easing(P3.utils.TWEEN.Easing.Linear.None)
			.onUpdate((v) => {
				const val = Math.floor(v.a);

				this.coinText.text = `${val}`;

				if (val % 1 === 0 && !this.tweenedValues.includes(val)) {
					this.tweenedValues.push(val);

					this.animateAddScore(this.coinText.position, common.scoring.coin);
				}
			})
			.onComplete(() => {
				this.tweenButtons();
			})
			.start();
	}

	setDBScore(data, resolve, reject) {
		/* $.ajax({
			type : 'POST',
			url  : 'http://dev.playerthree.com/p3scores/add.php',
			data : {
				table  : 'ben10_omnicode_scores',
				   u_id	  : data.payload.id,
				   score  : data.payload.score,
				   region : data.payload.region,
				   time   : data.payload.time,
				   age    : data.payload.age
			}
		}); */

		$.ajax({
			url  : 'https://jr9huo6y8e.execute-api.eu-west-1.amazonaws.com/testing/ben10-entry',
			type : 'POST',
			data : JSON.stringify({
				message: {
					payload: {
						id     : data.payload.id,
						score  : data.payload.score,
						region : data.payload.region,
						time   : data.payload.time,
						age    : data.payload.age
					},
					type: 'set_score'
				}
			}
			),
			dataType    : 'json',
			crossDomain : true,
			contentType : 'application/json',
			success     : (result) => {
				resolve(Object.assign({}, {type: 'success', payload: result}));
			},
			error: (err) => {
				reject({type: 'error', msg: 'An Error has occured when setting score', error: err});
			}
		});
	}

	getCompetitionEntry(id, resolve, reject) {
		$.ajax({
			url  : 'https://jr9huo6y8e.execute-api.eu-west-1.amazonaws.com/testing/ben10-entry',
			type : 'POST',
			data : JSON.stringify({
				message: {
					payload: {
						id: id
					},
					type: 'get_entry'
				}
			}),
			dataType    : 'json',
			crossDomain : true,
			contentType : 'application/json',
			success     : (result) => {
				resolve(Object.assign({}, {type: 'success', payload: result}));
			},
			error: (err) => {
				reject({type: 'error', msg: 'An Error has occured when getting user entry', error: err});
			}
		});
	}

	tweenButtons() {
		this.playButton.scale.set(2, 2);
		this.playButton.interactive = false;
		this.repeatButton.scale.set(2, 2);
		this.repeatButton.interactive = false;
		this.homeButton.scale.set(2);

		new P3.utils.TWEEN.Tween(this.playButton.scale, this.tweens)
			.to({x: 1, y: 1}, 500)
			.easing(P3.utils.Easing.Back2.Out)
			.onStart(() => {
				this.playButton.visible = true;
			})
			.start();

		new P3.utils.TWEEN.Tween(this.repeatButton.scale, this.tweens)
			.to({x: 1, y: 1}, 500)
			.easing(P3.utils.Easing.Back2.Out)
			.onStart(() => {
				this.repeatButton.visible = true;
			})
			.delay(100)
			.start();

		new P3.utils.TWEEN.Tween(this.homeButton.scale, this.tweens)
			.to({x: 1, y: 1}, 500)
			.easing(P3.utils.Easing.Back2.Out)
			.onStart(() => {
				this.homeButton.visible = true;
			})
			.delay(200)
			.onComplete(() => {
				this.setScore();

				this.playButton.interactive = true;
				this.repeatButton.interactive = true;
				this.homeButton.interactive = true;
			})
			.start();
	}

	playCompleteAnim() {
		const startAnim = 'complete_1';
		const nextAnim = 'idle1';

		this._spine.stateData.setMix(startAnim, nextAnim, 0.1);

		const spineState = this._spine.state;

		spineState.clearListeners();
		spineState.setAnimation(0, startAnim, false);

		spineState.addListener({
			complete: () => {
				spineState.clearListeners();
				spineState.setAnimation(0, nextAnim, true);
			}
		});
	}

	appear() {
		super.appear();

		common.THREEstage.remove.apply(common.THREEstage, common.THREEstage.children);
		this._backgroundMusic = P3.audio.playMusic('music_levels_loop_00');
	}

	update() {
		super.update();
		this._greenParticles && this._greenParticles.update();
		this._spine.update(P3.Ticker.dt);

		for (const particles of this._particles) {
			particles.update();
		}
	}

	_createCompetitionFrame() {
		const competitionPanel = new PIXI.mesh.NineSlicePlane(P3.assets.texture('collectables_splash_panel'), 10, 10, 10, 10);
		this.addChild(competitionPanel);

		this._competitionFrame = new PIXI.Container();
		this._competitionFrame.bg = competitionPanel;
		this.addChild(this._competitionFrame);

		const cookie = JSON.parse(localStorage.getItem('competition_entry'));
		const competitionAllowed = this.completedLevels.hasOwnProperty('1') || common.cheatActive;

		if (cookie) {
			this._scoreFrame = new PIXI.Container();
			this._competitionFrame.addChild(this._scoreFrame);

			this._competitionText = Text(translate('MENU.SELECT_LEVEL.COMPETITION.YOURSCORE'), {font: '24px Ahkio Thin', align: 'center'});
			this._competitionText.tint = 0xFFFFFF;
			this._competitionText.maxWidth = 380;
			this._competitionText.anchor.set(0, 0.5);
			this._scoreFrame.addChild(this._competitionText);

			let scoreText = Text('', {font: '28px Ahkio Regular', align: 'center'});
			scoreText.tint = 0xABF546;
			scoreText.maxWidth = 380;
			scoreText.anchor.set(0, 0.5);
			this._scoreFrame.addChild(scoreText);
			this._competitionFrame.scoreText = scoreText;

			const subheader = Text('', {font: '16px Ahkio Thin', align: 'center'});
			subheader.maxWidth = 380;
			subheader.tint = 0xFFFFFF;
			subheader.anchor.set(0.5);
			this._competitionFrame.addChild(subheader);
			this._competitionFrame.subheader = subheader;

			new Promise((resolve, reject) => {
				this.getCompetitionEntry(cookie.payload.id, resolve, reject);
			}).then((data) => {
				common.competitionData = data.payload;
				scoreText.text = `${data.payload.score}`;
				subheader.text = translate('MENU.SELECT_LEVEL.COMPETITION.PARENTAL_CONSENT');

				scoreText.position.set(this._competitionText.x + this._competitionText.width + 10, this._competitionText.y);
				this._scoreFrame.position.set(this._scoreFrame.width * -0.5, competitionPanel.height * -0.5 + 20);
				subheader.position.set(0, 20);

				this.resizeFrame();
			}).catch((data) => {
				console.error('Failed getting compeitition entry', data);
			});
		} else if (competitionAllowed) {
			this._competitionButton = new PIXI.mesh.NineSlicePlane(P3.assets.texture('competition_9slice_btn_off'), 70, 30, 70, 30);
			this._competitionButton.height = 75;
			this._competitionButton.interactive = this._competitionButton.buttonMode = true;
			this._competitionButton.on('pointertap', () => {
				this._competitionButton.visible = false;
				this.showCompetitionOverlay();
			}, this);
			this._competitionFrame.addChild(this._competitionButton);

			let buttonLabel = Text(translate('MENU.SELECT_LEVEL.COMPETITION.HEADER'), {font: '32px Ahkio Regular', align: 'center'});
			buttonLabel.tint = 0x0;
			buttonLabel.maxWidth = 300;
			buttonLabel.anchor.set(0.5);
			this._competitionFrame.addChild(buttonLabel);

			this._greenParticles = new ParticleEmitter('particle_endlvl_green', [
				P3.assets.texture('particle_endlvl_green')
			], true);
			this._greenParticles.enableLoop();
			this._greenParticles.play();
			this._competitionButton.addChild(this._greenParticles);

			this._competitionButton.width = buttonLabel.width + 40;
			this._competitionButton.height = buttonLabel.height + 40;
			this._competitionButton.position.set(this._competitionButton.width * -0.5, this._competitionButton.height * -0.5);
		} else {
			this._competitionText = Text(
				`${translate('MENU.SELECT_LEVEL.COMPETITION.LOCKED').replace('$SCORE$', common.totalScore)}`, {
					font  : '26px Ahkio Thin',
					align : 'center'
				});
			this._competitionText.tint = 0xFFFFFF;
			this._competitionText.maxWidth = 350;
			this._competitionText.anchor.set(0.5);
			this._competitionFrame.addChild(this._competitionText);
		}

		const badge = new PIXI.Sprite(P3.assets.texture('collectables_splash_badge'));
		badge.anchor.set(0.5, 0.5);
		this.addChild(badge);
		this._competitionFrame.badge = badge;

		if (this._competitionButton) {
			competitionPanel.height = this._competitionButton.height + 20;
		} else {
			competitionPanel.height = badge.height - 40;
		}

		this.resizeFrame();
	}

	resizeFrame() {
		const fr = this._competitionFrame;
		const exemption = !['en', 'ro'].includes(common.config.language);

		const factor = this._competitionButton && exemption ? 40 : -10;
		fr.position.set(common.STAGE_WIDTH * 0.5, common.STAGE_HEIGHT - fr.height + factor);
		fr.bg.position.set(common.STAGE_WIDTH * 0.5 - fr.bg.width * 0.5, fr.y - fr.bg.height * 0.5);
		fr.badge.position.set(fr.bg.x - 20, fr.y);
	}

	onResume(result) {
		this.paused = false;
		if (result === 'accepted') {
			this._competitionButton.destroy({children: true});

			this._scoreFrame = new PIXI.Container();
			this._competitionFrame.addChild(this._scoreFrame);

			this._competitionText = Text(translate('MENU.SELECT_LEVEL.COMPETITION.YOURSCORE'), {font: '24px Ahkio Thin', align: 'center'});
			this._competitionText.tint = 0xFFFFFF;
			this._competitionText.maxWidth = 380;
			this._competitionText.anchor.set(0, 0.5);
			this._competitionText.visible = false;
			this._scoreFrame.addChild(this._competitionText);

			let scoreText = Text('', {font: '28px Ahkio Regular', align: 'center'});
			scoreText.tint = 0xABF546;
			scoreText.maxWidth = 380;
			scoreText.anchor.set(0, 0.5);
			scoreText.visible = false;
			this._scoreFrame.addChild(scoreText);
			this._competitionFrame.scoreText = scoreText;

			const subheader = Text('', {font: '16px Ahkio Thin', align: 'center'});
			subheader.maxWidth = 380;
			subheader.tint = 0xFFFFFF;
			subheader.anchor.set(0.5);
			subheader.visible = false;
			this._competitionFrame.addChild(subheader);
			this._competitionFrame.subheader = subheader;

			const cookie = JSON.parse(localStorage.getItem('competition_entry'));
			new Promise((resolve, reject) => {
				this.getCompetitionEntry(cookie.payload.id, resolve, reject);
			}).then((data) => {
				this._competitionButton.destroy({children: true});
				this._competitionButton = null;

				common.competitionData = data.payload;

				this._competitionText.visible = true;
				scoreText.visible = true;
				subheader.visible = true;

				this._competitionFrame.scoreText.text = `${this.getTotalScore()}`;
				this._competitionFrame.subheader.text = translate('MENU.SELECT_LEVEL.COMPETITION.PARENTAL_CONSENT');

				this._competitionFrame.scoreText.position.set(this._competitionText.x + this._competitionText.width + 10, this._competitionText.y);
				this._scoreFrame.position.set(this._scoreFrame.width * -0.5, this._competitionFrame.bg.height * -0.5 + 30);
				this._competitionFrame.subheader.position.set(0, 20);

				this._competitionFrame.bg.height = this._competitionFrame.badge.height - 40;
				this.resizeFrame();
			}).catch((data) => {
				console.error('Failed setting competition entry', data);
			});
		} else {
			this._competitionButton.visible = true;
		}
	}

	showCompetitionOverlay() {
		this.signals.pause.dispatch();
	}

	onPause() {
		this.paused = true;
	}

	resize() {
		super.resize();

		this.homeButton.position.set(((common.STAGE_WIDTH - P3.View.width) * 0.5) + 75, 75);
	}
}
